import { motion } from "framer-motion";
import styled from "styled-components";
import { BORDER_COLORS } from "../../constants/design/colors";
import { COMPONENTS, SPACING } from "../../constants/design/spacing";
import { frostedGlassBg } from "../shared/style";

export const MobileFooterWrapper = styled(motion.div)`
  overflow: hidden;
  position: sticky;
  z-index: 3;
  left: 0;
  right: 0;
  bottom: 0;
  height: ${COMPONENTS.footer.mobileNav}px;
  display: flex;
  justify-content: center;
  padding: ${SPACING.two}px;
  border-top: 1px solid ${BORDER_COLORS.one};

  /* Near-opaque so the chart/orderbook scrolling underneath doesn't bleed
     through the docked Buy/Sell bar (previously 16% opacity → looked like the
     buttons overlapped the chart). */
  ${frostedGlassBg("rgba(6, 6, 12, 0.94)", "rgba(6, 6, 12, 0.98)", 12)}

  > button {
    min-height: 0;
    flex: 1;

    &:not(:last-child) {
      margin-right: ${SPACING.two}px;
    }
  }
`;
